import { styled, Typography } from '@mui/material'

export const UnknownClientID = styled(Typography)({
  width: 'fit-content',
  '&:hover': {
    cursor: 'pointer',
    textDecoration: 'underline'
  }
})
